import { downloadFileFromURL } from '@packages/files';
import { AxiosRequestConfig } from 'axios';

export class Repository {
    protected withParams(config: AxiosRequestConfig = {}, params: { [key: string]: any } = {}) {
        return {
            ...config,
            params: {
                ...(config?.params ?? {}),
                ...params,
            },
        };
    }
    protected downloadFileFromURL(url: string) {
        return downloadFileFromURL(url);
    }
}
